import { useMemo } from 'react'
import { type SimpleSelectOption } from '@workwave-tidal/core/components'
import { useTexts } from './useTexts'

export function useOptions() {
  const texts = useTexts()

  return useMemo<SimpleSelectOption<string>[]>(() => {
    return optionsId.map(id => {
      switch (id) {
        case 'NEVER':
          return { value: id, label: texts.never }
        case 'AFTER_NUMBER':
          return { value: id, label: texts.afterNumber }
        case 'ON_DATE':
          return { value: id, label: texts.onDate }
      }
    })
  }, [texts])
}

const optionsId = ['NEVER', 'AFTER_NUMBER', 'ON_DATE'] as const
